import { FC } from 'react';

import SelectableOptionCard from '@/shared/components/cards/SelectableOptionCard';
import { SetStateMethod } from '@/types';

interface DashboardTemplateItemProps {
    dt: any;
    dtIndex: number;
    template: string;
    setTemplate: SetStateMethod<string>;
}

const DashboardTemplateItem: FC<DashboardTemplateItemProps> = ({ dt, dtIndex, setTemplate, template }): JSX.Element => {
    return (
        <SelectableOptionCard
            borderStyle={dtIndex === 0 ? 'solid' : 'dashed'}
            description={dt?.description}
            icon={dt?.avatar}
            label={dt?.label}
            selected={template === dt?.key}
            onSelect={() => setTemplate(dt?.key)}
        />
    );
};

export default DashboardTemplateItem;
